/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* global document, jQuery */
/* eslint-disable */
(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
          $(document).on("mouseout", function(e) {
            e = e ? e : window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName == "HTML") {
              // stop your drag event here
              // for now we can just use an alert
              if (window.localStorage && !window.localStorage.getItem('seenWOF')) {
                $('.wof-container').show();
                $('.wof-container').removeClass('hidden');
                window.localStorage.setItem('seenWOF', true);
                $('.wof-open').hide();
              }
            }
          });

          $('.wof-open').click(function() {
            $('.wof-container').show();
            $('.wof-container').removeClass('hidden');
            window.localStorage.setItem('seenWOF', true);
            $('.wof-open').hide();
          });

        // if ($('body').hasClass('admin-bar') && $('.display-name').html() === 'jake') {
          var spin = $(".wof-spin");
          var wheel = $('svg #vinyl_record');
          var email = $('.wof-email');
          var message = $('.wof-message');
          var form = $('form-items');

          var difference = 360 / 10;

          var tenoff = [0, 2, 4];
          var otherwin = [3, 6, 7, 9];
          var hundredoff = [3, 7];
          var tenpoundoff = [9];
          var fiveoff = [6];

          var prizes = [
            '10 percent off any purchase',
            false,
            '10 percent off any purchase',
            '£100 off any purchase over £1000',
            '10 percent off any purchase',
            false,
            '5% off any purchase',
            '£100 off any purchase over £1000',
            false,
            '£10 off any purchase over £100'
          ];

          var codes = [
            'W1U10OFF-3DHJS',
            false,
            'W1U10OFF-4FJ43',
            '3SG100OFF-032FF',
            'W1U10OFF-99NDS',
            false,
            'AUDIO5OFF-654VD',
            '3SG100OFF-7VT56',
            false,
            'AL10OFF-MN6GG'
          ];

          var kindofwin;

          $(document).on('click', '.wof-spin', function () {
            kindofwin = Math.random();
            $('#nf-field-26').val(kindofwin);
          });

          $(document).on('nfFormSubmitResponse', function() {
            message.html('<strong>Spinning...</strong>');
            message.show();

            var preSpins = Math.floor(Math.random() * 8) + 4;

            var randRotation;

            var position;
            if (kindofwin <= 1) {
              position = tenoff[Math.floor(Math.random() * 3)];
            } else {
              position = otherwin[Math.floor(Math.random() * 4)];
            }

            randRotation = position * difference;

            TweenMax.to(wheel, 0, { rotation: 0 });
            ThrowPropsPlugin.to(wheel, {
              throwProps: {
                transformOrigin: "center",
                rotation: {
                  velocity: -50,
                  end: (preSpins * 360) + randRotation
                }
              },
              onComplete: function() {
                message.html('<p>Congratulations! you\'ve won <strong>' + prizes[position] + '</strong>.</p><p>Your code is <strong>' + codes[position] + '</strong></p>');
              }
            });
          });
          $('.wof-container').click(function (e) {
            if (!$(e.target).hasClass('nf-element') && $(e.target).closest('.wof-background').length === 0) { 
              $('.wof-container').addClass('hidden');
              window.localStorage.setItem('seenWOF', true);
              $('.wof-open').show();
            }
          });
          $('.wof-close').click(function() {
            $('.wof-container').addClass('hidden');
            window.localStorage.setItem('seenWOF', true);
            $('.wof-open').show();
          });

          $('.wof-container').bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
            if ($('.wof-container').hasClass('hidden')) {
              $('.wof-container').hide();
              window.localStorage.setItem('seenWOF', true);
              $('.wof-open').show();
            }
          });

        // }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    page_template_template_testimonials: {
      init: function() {
        var defaultImg = $('.testimonial img').attr('src');

        $('.testimonial-gallery-item').click(function(e) {
          e.preventDefault();
          $(this).parents('.testimonial').children('.gallery-image').attr('src', $(this).attr('href'));
        });

        // $('.testimonial-gallery-item').mouseout(resetImg);
      }
    },
    product_template_default: {
      init: function() {
        $('.enquire-product').click(function() {
          $(this).slideUp();
          // $(this).e
          $('#enquiry-collapse').slideDown();
        });
        $('#enquiry-collapse .close').click(function() {
          $('#enquiry-collapse').slideUp();
          $('.enquire-product').slideDown();
        });
      }
    },
    archive: {
      init: function() {
        $('.filters-toggle').click(function() {
          $('#secondary').addClass('show');
        });

        $('.hide-filters').click(function() {
          $('#secondary').removeClass('show');
        });

        $('#secondary input').click(function () {
          $('#secondary').removeClass('show');
        });

        $('#secondary label').click(function () {
          $('#secondary').removeClass('show');
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      funcname = funcname || 'init';
      if (Sage[func] && Sage[func][funcname] && typeof Sage[func][funcname] === 'function') {
        Sage[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
}(jQuery)); // Fully reference jQuery after this point.
